import { watchEffect } from '@vue/composition-api';
import useSupportHours from '@/compositions/useSupportHours';
import { importScript } from './utils.js';

export default class Chat {
  static isChatAvailable = false;

  static isChatOverlayAvailable = false;

  static commonStore = null;

  static async init(commonStore) {
    Chat.commonStore = commonStore;
    Chat.checkChatAvailable();

    window.__lc = window.__lc || {};
    window.__lc.license = process.env.NODE_ENV === 'production' ? 7555871 : 12149736;
    await importScript('https://cdn.livechatinc.com/tracking.js');

    const LC_API = window.LC_API || {};

    LC_API.on_before_load = () => LC_API.hide_chat_window();

    LC_API.on_after_load = () => {
      const currentUrl = new URL(window.location.href);
      const toOpenChat = currentUrl.searchParams.get('chat') === 'open';

      if (currentUrl.pathname === '/' && toOpenChat) {
        this.start();
        return;
      }

      Chat.setLCDefault();
    };

    LC_API.on_chat_window_opened = () => window.heap.track('NumTimesLivechatOpened', {});
    LC_API.on_prechat_survey_submitted = (data) => window.heap.track('NumTimesLivechatPresurveyFilled', {});
  }

  static setLCDefault() {
    if (window.LC_API) {
      const { LC_API } = window;
      if (LC_API.visitor_engaged && !LC_API.visitor_engaged()) {
        const { livechatOverlayEnabled } = window; // mm setting
        if (!livechatOverlayEnabled || !Chat.isChatOverlayAvailable) LC_API.hide_chat_window();
        else LC_API.minimize_chat_window();
      }
    }
  }

  static async start(afterHoursUrl) {
    const LC_API = window.LC_API || {};

    if (!Chat.isChatAvailable) {
      window.location.href = afterHoursUrl;
    } else if (LC_API.open_chat_window) {
      LC_API.open_chat_window();
    }
  }

  /**
   * Checking if chat is available
   * @returns {boolean}
   */
  static checkChatAvailable() {
    const currentTime = new Date(Date.now());

    const weekdays = {
      1: 1,
      2: 1,
      3: 1,
      4: 1,
      5: 1,
    };

    const weekend = {
      6: 1,
      0: 1,
    };

    const {
      csChatWeekdaysHoursStart, //
      csChatWeekdaysHoursEnd,
      csChatWeekendHoursStart,
      csChatWeekendHoursEnd,
      csChatOverlayWeekdaysHoursStart,
      csChatOverlayWeekdaysHoursEnd,
      csChatOverlayWeekendHoursStart,
      csChatOverlayWeekendHoursEnd,
    } = useSupportHours(Chat.commonStore);

    watchEffect(() => {
      Chat.isChatAvailable = false;
      Chat.isChatOverlayAvailable = false;

      if (csChatWeekdaysHoursStart.value && csChatWeekdaysHoursEnd.value && currentTime.getDay() in weekdays) {
        if (currentTime.getTime() >= csChatWeekdaysHoursStart.value?.getTime() && currentTime.getTime() < csChatWeekdaysHoursEnd.value?.getTime()) {
          Chat.isChatAvailable = true;
        }
      } else if (csChatWeekendHoursStart.value && csChatWeekendHoursEnd.value && currentTime.getDay() in weekend) {
        if (currentTime.getTime() >= csChatWeekendHoursStart.value?.getTime() && currentTime.getTime() < csChatWeekendHoursEnd.value?.getTime()) {
          Chat.isChatAvailable = true;
        }
      }

      if (csChatOverlayWeekdaysHoursStart.value && csChatOverlayWeekdaysHoursEnd.value && currentTime.getDay() in weekdays) {
        if (
          currentTime.getTime() >= csChatOverlayWeekdaysHoursStart.value?.getTime() &&
          currentTime.getTime() < csChatOverlayWeekdaysHoursEnd.value?.getTime()
        ) {
          Chat.isChatOverlayAvailable = true;
        }
      } else if (csChatOverlayWeekendHoursStart.value && csChatOverlayWeekendHoursEnd.value && currentTime.getDay() in weekend) {
        if (
          currentTime.getTime() >= csChatOverlayWeekendHoursStart.value?.getTime() &&
          currentTime.getTime() < csChatOverlayWeekendHoursEnd.value?.getTime()
        ) {
          Chat.isChatOverlayAvailable = true;
        }
      }

      Chat.setLCDefault();
    });
  }
}
